<template lang="pug">
VueFeedback(type="error")
	template(slot="feedback-title") A technical error has occurred
</template>

<script>
import VueFeedback from '@ui-common/vue-feedback';
export default {
	components: {
		VueFeedback
	}
};
</script>
